<script>
import { Article, ArticleTag } from '@/api'
import fields from '@/components/fields/'
import moment from 'moment'
import PageFormBase from '@/crudBases/form/PageFormBase'

export default {
  mixins: [PageFormBase],
  data() {
    return {
      form: {
        widgets: []
      },
      tagOptions: [],
      redirectRoute: { name: 'Article List' },
      livePreview: true
    }
  },
  created() {
    this.fetchTags()
    if (this.form.publication_date === undefined) {
      this.$set(this.form, 'publication_date', moment().format('YYYY-MM-DD'))
    }
  },
  methods: {
    fetchTags() {
      const params = { page_size: 'max' }
      ArticleTag.fetch({}, { params }).then(res => {
        this.tagOptions = res.data.results.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            this.getGeneralTab(),
            this.getWidgetsTab(),
            this.getPreviewTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            required: true,
            modelPath: [this, 'form', 'title'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Input({
            label: 'Lead',
            required: true,
            modelPath: [this, 'form', 'lead'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Select({
            label: 'Tagi',
            modelPath: [this, 'form', 'tags'],
            multiple: true,
            filterable: true,
            allowCreate: true,
            options: this.tagOptions
          }),
          new fields.Date({
            label: 'Data publikacji',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            modelPath: [this, 'form', 'publication_date'],
            required: true
          })
        ]
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return Article
    },
    livePreviewUrl() {
      return '/preview/articles/'
    }
  }
}
</script>
